import React from 'react'
import classnames from 'classnames'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import { Row, Col } from 'react-flexbox-grid'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import TitledLabel from '../../controls/TitledLabel'
import { localize } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'
import GenericModal from '../../widgets/common/GenericModal'

class DrugClaimExpenseLine extends React.Component {
  constructor () {
    super()
    this.state = { showGenericModal: false }
  }

  render () {
    let { expenseDetail, hasCOB, classes = {} } = { ...this.props }
    return (
      <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
        {this.state.showGenericModal
          ? <GenericModal
            open={this.state.showGenericModal}
            handleOk={() => {
              this.props.onDelete(this.props.index)
              this.setState({ showGenericModal: false })
            }}
            handleClose={() => {
              this.setState({ showGenericModal: false })
            }}
            showOk
            OkButtonText={localize('yesText')}
            CancelButtonText={localize('noText')}
            modal
            message={localize('pages.SubmitAClaim.DeleteWarning')}
          /> : null }
        <Row>
          <Col xs={12} sm={12} md={8} lg={8}>
            <Row>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.ServiceDate' format='date' value={expenseDetail.ServiceDate} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.DIN-NPN-HPN' format='text' value={expenseDetail.DrugInfo.DrugIdentificationNumber} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.RX' format='text' value={expenseDetail.DrugInfo.RxNumber} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.ProvinceOfPharmacy' format='text' value={expenseDetail.DrugInfo.Province} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.NumberOfDaysSupply' format='text' value={expenseDetail.DrugInfo.DaysOfSupply} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.QuantityType' format='text' value={expenseDetail.DrugInfo.DrugQuantityType} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.DrugQuantity' format='text' value={expenseDetail.DrugInfo.DrugQuantity} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.DrugCostWithoutDispenseFee' format='currency' value={expenseDetail.DrugInfo.DrugCost} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Drug.DispenseFee' format='currency' value={expenseDetail.DrugInfo.DispenseFee} />
              </Col>
              {hasCOB &&
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.AmountReceivedFromAllOtherInsurance' format='currency' value={expenseDetail.COBField.COBAmount} />
              </Col>
              }
            </Row>
          </Col>
          <Col xs={12} sm={12} md={4} lg={4}>
            <Row end='lg' middle='xs'>
              <Col xs={12}>
                <RBButton
                  variant='outlined'
                  styles={{ margin: '0px 5px' }}
                  label={localize('pages.SubmitAClaim.Expenses.DeleteButton')}
                  onClick={() => this.setState({ showGenericModal: true })} className='submitNavButton' />
                <RBButton variant='outlined' styles={{ margin: '0px 5px' }}
                  label={localize('pages.SubmitAClaim.Expenses.EditButton')}
                  onClick={() => this.props.onEdit(this.props.index)} className='submitNavButton' />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    )
  }
}

const styles = {
  ...CardStyles
}

export default withStyles(styles)(DrugClaimExpenseLine)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/DrugClaimExpenseLine.js